
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M5.25 16.615a.75.75 0 01.75-.75h10a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M7.538 2.75a.788.788 0 00-.788.788v14.616c0 .435.353.788.788.788h6.923a.788.788 0 00.789-.788V3.538a.788.788 0 00-.789-.788H7.538zm-2.288.788A2.288 2.288 0 017.538 1.25h6.923a2.288 2.288 0 012.289 2.288v14.616a2.289 2.289 0 01-2.289 2.288H7.538a2.288 2.288 0 01-2.288-2.288V3.538z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M10.192 5.49h2.972a.75.75 0 010 1.5h-2.998c-.02 0-.04 0-.06-.002a.433.433 0 00-.466.466c.002.02.002.04.002.06V7.51c.003 0 .032.132.385.412.347.277.827.556 1.376.872l.03.017c.511.296 1.085.627 1.53.98.41.326.947.85.95 1.575a2.003 2.003 0 01-2.029 2.031H8.892a.75.75 0 010-1.5h3.012a.5.5 0 00.51-.51v-.01c-.003.001-.032-.132-.384-.412-.348-.276-.828-.555-1.377-.872l-.03-.017c-.511-.295-1.085-.626-1.53-.98-.406-.322-.935-.838-.95-1.55a1.933 1.933 0 012.05-2.056z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M11.028 3.889a.75.75 0 01.75.75V6.24a.75.75 0 01-1.5 0v-1.6a.75.75 0 01.75-.75zm0 8.008a.75.75 0 01.75.75v1.602a.75.75 0 01-1.5 0v-1.602a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    